import MapMaker from "../utils/MapMaker";

export default class BlockMap {

	constructor() {

		let blockMaps = document.querySelectorAll('.map-inner');

		if (!blockMaps) {
			return;
		}

		window.addEventListener("googleMapApiLoaded", () => {

			blockMaps.forEach((blockMap) => {
				let markers = blockMap.querySelectorAll('.map-marker');

				if (blockMap.dataset.type === "static") {

					MapMaker.createStaticMap(blockMap, markers);

				} else {

					const observer = new MutationObserver((mutations) => {
						mutations.forEach((mutation) => {
							const target = mutation.target;
							const card = target.querySelector('.card-program');
							if (mutation.attributeName === 'class'){
								const marker = map.markers.find(m => m.markerId === card.dataset.index);
								marker.map = ( target.classList.contains('d-none') ) ? null : map;
							}
						});
						MapMaker.updateBounds(map);
					});

					let map = MapMaker.createDynamicMap(blockMap);

					if (blockMap.dataset.zoom) {
						map.setZoom(parseInt(blockMap.dataset.zoom));
					}

					markers.forEach((m) => {
						MapMaker.createMarker(m, map);
					});

					MapMaker.updateBounds(map);

					const cards = document.querySelectorAll('.card-program');
					cards.forEach( card => {
						card.addEventListener("mouseenter", () => {
							const index = card.dataset.index;
							const marker = map.markers.find(m => m.markerId === index);
							const event = new MouseEvent('mouseenter', {
								view: window,
								bubbles: true,
								cancelable: true
							});
							marker.content.dispatchEvent(event);
						});
						card.addEventListener("mouseleave", () => {
							const index = card.dataset.index;
							const marker = map.markers.find(m => m.markerId === index);
							const event = new MouseEvent('mouseleave', {
								view: window,
								bubbles: true,
								cancelable: true
							});
							marker.content.dispatchEvent(event);
						});

						// Observation de l'état du parent
						const targetNode = card.closest('.col-program-card');
						observer.observe(targetNode, { attributes: true });

					});

				}
			});

		});
	}

}
